import Loadable from 'react-loadable';
import Loading from '../../common/Loader/index';

const loadableService = Loadable({
  loader: () => import('./index'),
  loading: () => <Loading showLoader={true} />,
});

export default loadableService;
